import { createStyles, Theme } from '@material-ui/core/styles';
import { BrightBackground } from '../../../theme/theme';

const style = (theme: Theme) => createStyles({

    panel: {
        flex: '1 1 150px',
        overflow: 'auto',
    },

    paramsPanel: {
        flex: '1 1 150px',
        display: 'flex',
        flexDirection: 'column',
    },

    paramsContainer: {
        flex: '1 1 110px',
        display: 'flex',
        overflow: 'auto',
    },

    paramEditContainer: {
        display: 'flex',
        alignItems: 'center',
        padding: `${theme.spacing.unit / 3}px ${theme.spacing.unit}px`,
        minHeight: 26,

        '&:nth-child(2n)': {
            backgroundColor: BrightBackground,
        },
    },

    paramEditLabel: {
        flex: '1 1 150px',
        maxWidth: '250px',
        marginRight: theme.spacing.unit,
    },

    paramEditInputContainer: {
        flex: '1 1 150px',
        display: 'flex',
    },

    paramEditInputContainerNotCheck: {
        flexDirection: 'column',
        alignItems: 'stretch',
    },

    minimizePanel: {
        flex: '0 0 31px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
        '& svg': {
            width: '24px',
            height: '24px',
        },
    },

    optimizationHeader: {
        display: 'flex',
        justifyContent: 'center',
        '& p': {
            borderBottom: `1px solid ${theme.palette.divider}`,
            fontWeight: 600,
        },
    },

    optimizeParamContainer: {
        width: '100%',
        padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },

    optimizeParamLabel: {
        flex: '0 1 250px',
        marginRight: theme.spacing.unit,
    },

    optimizeParamInput: {
        flex: '0 0 50px',
        maxHeight: '21px',
    },

    optimizeButtonContainer: {
        marginBottom: theme.spacing.unit * 2,
        width: '100%',
        padding: theme.spacing.unit / 2,
        display: 'flex',
        justifyContent: 'space-evenly',
    },

    optimizeText: {
        width: '100%',
        padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit}px`,
    },

    optimizeTableContainer: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },

});

export default style;
